module.exports = __webpack_public_path__ + "character2.266fa275.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/character2.png
// module id = X4ol
// module chunks = 0